'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookieAuthentication = undefined;

var _cookieAuth = require('./cookieAuth');

var domainsConfig = [{
  csrfCookieName: 'csrf.api',
  matcher: /^[a-z0-9]+\.hubapi(qa)?\.com$/
}, {
  csrfCookieName: 'csrf.app',
  matcher: /^[a-z0-9]+\.hubspot(qa)?\.com$/
}];

var externalCookieAuthentication = (0, _cookieAuth.cookieAuthentication)(domainsConfig);

exports.cookieAuthentication = externalCookieAuthentication;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.161/js/middlewares/externalAuth.js
// module id = 389
// module chunks = 0